import {useEffect, useRef} from 'react';
import "./Confirmation.scss";
import {useConfig} from '../ConfigProvider';
import StyledStepFooter from '../StyledStepFooter';
import {useTunnelData} from "../TunnelContext";
import {useAnalytics} from "../analytics";

export default function Confirmation(){
  const {tunnel, reinitTunnel} = useTunnelData();
  const config = useConfig();
  const {trackTunnelCompleted} = useAnalytics();
  const hasTracked = useRef(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (!hasTracked.current) {
      trackTunnelCompleted();
      hasTracked.current = true;
    }
    if( tunnel.club?.fbq && window.fbq) {
      window.fbq('track', 'PageView');
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tunnel.club?.fbq]);

  // Add automatic reinitialization of the tunnel if configured
  // Same code as StepsDisplay.jsx (without step condition)
  useEffect(() => {
    if (config.navigation?.reinitAuto) {
      const interval = setInterval(() => {
        reinitTunnel();
      }, config.navigation?.reinitAutoSecs * 1000);

      return () => clearInterval(interval);
    }
  }, [config.navigation?.reinitAuto, config.navigation?.reinitAutoSecs, reinitTunnel]);


  return (
      <main className="Confirmation">
        {config.confirmation.tracker && config.confirmation.tracker(tunnel) }
        <section>
          <h2>{config.confirmation.welcomeLabel} {config.companyName} !</h2>
          <div className='confirmationImg'><span>Success</span></div>
          <p>{config.confirmation.text}</p>
        </section>
        <StyledStepFooter>
          { config.confirmation.backLabel &&
            <a style={{
              background: config.theme.primary,
              color: "white",
              textAlign: "center",
              fontWeight: "bold",
              padding:'0.5rem'
            }}
            href={config.website}>{config.confirmation.backLabel}</a>
          }
          { config.confirmation.restartLabel &&
            <button type="button" onClick={reinitTunnel} style={{
              background: config.theme.primary,
              color: "white",
              textAlign: "center",
              fontWeight: "bold",
              padding:'0.5rem',
              cursor:'pointer'
            }}>
              {config.confirmation.restartLabel}
            </button>
          }

        </StyledStepFooter>
      </main>
  );
}




